export const popover = (theme) => ({
    variants: {
        info: {
            background: theme.colors?.component?.elevated,
            color: theme.colors?.text?.basic?.primary,
            boxShadow: theme.shadows?.md,
            borderRadius: theme.radii?.sm,
        },
        tooltip: {
            background: theme.colors?.component?.inverse,
            color: theme.colors?.text?.basic?.inverse,
            boxShadow: theme.shadows?.md,
            borderRadius: theme.radii?.sm,
        },
        danger: {
            background: theme.colors?.component?.negative?.default,
            color: theme.colors?.text?.basic?.onColor,
            boxShadow: theme.shadows?.md,
            borderRadius: theme.radii?.sm,
        },
        none: {
            background: 'none',
            color: 'inherit',
            boxShadow: theme.shadows?.sm,
            borderRadius: 'inherit',
        },
    },
});
//# sourceMappingURL=popover.js.map